import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import getConfig from '../../../util/config';
import { getAccountProfileName } from '../views/UserPage/helpers';
import { getThumbBySize } from '../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../constants/image-size-codes';
import { ALBUM_PRIVACY } from '../../../constants/albums';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    hero_image: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
    account: PropTypes.shape({
      id: PropTypes.string.isRequired,
      organization_name: PropTypes.string,
      hero_image: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }),
    }).isRequired,
  }).isRequired,
};

const WebGalleryAlbumFolderMeta = ({ albumFolder }) => {
  if (!albumFolder) return null;

  const {
    app: { pageUrl },
  } = getConfig();
  const { account } = albumFolder ?? {};
  const heroImage = albumFolder?.hero_image?.url ?? account?.hero_image?.url;
  const coverPhoto = getThumbBySize(
    albumFolder.cover_photos?.records?.[0]?.thumbnail_urls,
    IMAGE_SIZE_CODE.MEDIUM2X,
  )?.url;
  const title = `${albumFolder.name} - ${getAccountProfileName(
    account,
  )} - Waldo Photos`;
  const description = `Browse all photos of ${
    albumFolder.name
  } by ${getAccountProfileName(account)} for free!`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {(heroImage || coverPhoto) && (
        <meta property="og:image" content={heroImage || coverPhoto} />
      )}
      {albumFolder?.privacy === ALBUM_PRIVACY.PRIVATE && (
        <meta name="robots" content="noindex" />
      )}
    </Helmet>
  );
};

WebGalleryAlbumFolderMeta.propTypes = propTypes;

export default WebGalleryAlbumFolderMeta;
